// this directive prevents clicks from bleeding through a mat-select backdrop, when the mat-select is itself embedded in a popup control
import { AfterViewInit, Directive } from "@angular/core";
import { MatSelect } from '@angular/material/select';

@Directive({
    selector: "[sa-mat-select-backdrop-click-handler]"
})
export class MatSelectBackdropClickHandlerDirective implements AfterViewInit
{
    constructor(private host: MatSelect) { }
    ngAfterViewInit(): void {
        // angular 13 todo - in Angular 12 - we need to use MatSelectModule instead of MatSelect (refer - https://github.com/angular/components/issues/24229)
        /*
         this.host.overlayDir.backdropClick.subscribe((event) => {
            event.stopPropagation();
        })
        */
    }
}